import SortButton from './SortButton';
import FilterSelect from './FilterSelect';

const TableHeaderCell = ({ 
  label, 
  rowSpan = 1,
  sortState,
  onSort,
  filterValue,
  filterOptions,
  onFilterChange,
  filterPlaceholder,
  showFilter = false,
  showSort = false,
  children
}) => {
  return (
    <th rowSpan={rowSpan} className="text-center">
      <div>
        {label}
        {showSort && <SortButton sortState={sortState} onClick={onSort} />}
        {showFilter && (
          <FilterSelect
            value={filterValue}
            options={filterOptions}
            onChange={onFilterChange}
            placeholder={filterPlaceholder}
          />
        )}
        {children}
      </div>
    </th>
  );
};

export default TableHeaderCell;
